module.exports = fox._r("images/gallery/error.gif", __webpack_public_path__ + "_/_/_/root/images/gallery/error.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/gallery/error.gif
// module id = 430
// module chunks = 4